import { RootState } from "../..";

export const selectCurrent = (state: RootState) => state.rule.data.current;

export const selectIsCurrentLoading = (state: RootState) =>
  state.rule.loading.current;

export const selectError = (state: RootState) => state.rule.error.current;
